import React, { useEffect } from 'react';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import { useDispatch, useSelector } from 'react-redux';
import SearchProgressModalContent from './Components/SearchProgressModalContent';
import SearchProgressModalFooter from './Components/SearchProgressModalFooter';
import './SearchProgressModal.scss';
import { cancelSearch, destroy, init, dispatchCloseSearchProgressModal } from './SearchProgressModalActions';
import { searchProgressModalReducerKey } from './SearchProgressModalConstants';
import useSearchedDatabase from './useSearchedDatabase';

function SearchProgressModal(props) {
  const currentState = useSelector((state) => state.get(searchProgressModalReducerKey));
  const { singleDatabase, currentDbName } = useSearchedDatabase(currentState);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(init(currentState.queries || []));
    return () => {
      dispatch(destroy());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="react-dialogs-backdrop" />
      <GeneralDialogLayout
        {...props}
        className="search-progress-modal"
        size="sm"
        closeBtn={false}
        headerClassName="rx-border-none"
        footerClassName="rx-border-none"
        footer={
          <SearchProgressModalFooter
            cancelSearch={() => {
              cancelSearch(currentState.searchId, currentState.requestId);
              dispatchCloseSearchProgressModal();
            }}
          />
        }>
        <SearchProgressModalContent singleDatabase={singleDatabase} currentDbName={currentDbName} />
      </GeneralDialogLayout>
    </>
  );
}

export default SearchProgressModal;
